import { getLiveChatV2Template, getVueLiveChatV2Template } from "../../shortcodes/templates";

let liveChatV2Shortcode = null;
const visualizeLiveChatV2 = content => {
  liveChatV2Shortcode = content.querySelectorAll('[data-wrapper-id="live-chat-v2-shortcode"]');

  if (liveChatV2Shortcode.length > 0) {
    liveChatV2Shortcode.forEach(item => {
      item.innerHTML = getLiveChatV2Template();
    });
  }
};

const serializeLiveChatV2 = content => {
  const liveChatV2Shortcode = content.querySelectorAll('[data-wrapper-id="live-chat-v2-shortcode"]');
  if (liveChatV2Shortcode.length > 0) {
    liveChatV2Shortcode.forEach(item => {
      const liveChatData = item.getAttribute("data-live-chat-data");
      item.innerHTML = getVueLiveChatV2Template(liveChatData);
    });
  }
};

export { visualizeLiveChatV2, serializeLiveChatV2 };
